import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import { postRequest } from "../../api/ApiService";
import Rheostat from "rheostat";
import SliderHandleButton from "../../components/ui-building-blocks/slider/SliderHandleButton";
import SweetAlert from "sweetalert-react";
import EventEmitter from "../../services/event-emitter";
import { logError } from "../../services/utils";
import HelpIconButtonWithTooltipAndTypeformModal from "../../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import { incrementUnacceptedDecisions } from "../../api/SubmitDecisions";
import MgBusinessCaseContent from "../../components/typeform/MgBusinessCaseContent";
import Fragment from "react-dot-fragment";

export default class ModalPDDecisionsAddProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: {
        name: "",
        pixels_rank: 5,
        sensitivity_rank: 5,
        power_rank: 5,
        temp_range_rank: 5
      },
      creatingProduct: false,
      isError: false,
      showAlert: false,
      alertText: ""
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showPopup = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      'Nice work! You\'ve created a product, but is there a market?',
      'Essentially will a customer buy your product given its features',
      <Fragment>
        <b>I like you so here's a hint</b><br />
        Understand the customer needs/wants first (i.e. review <a href="/ceo/analysis/market" target="_blank">customer analysis</a>)...you're welcome!
      </Fragment>
    ]);
  };

  showPopup2 = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      'Heads up! Your product won\'t be released this year given your product features ranking (i.e. its higher quality).',
      'The higher the design quality, the longer it takes for your product to be released to the market.',
      <Fragment>
        <b>Here's the real dilemma, as with most Product Managers (PMs):</b><br />
        Do you build a higher quality product now and forgo potential revenues this
        year or create a lower quality product now and upgrade features as you go?
      </Fragment>
    ]);
  };

  updateProductState = (sliderState, key) => {
    let [new_val] = sliderState.values;
    let product = { ...this.state.product };

    product[key] = new_val;

    this.setState({
      product
    });
  };

  updatePixelsRank = sliderState => {
    this.updateProductState(sliderState, "pixels_rank");
  };

  updateSensitivityRank = sliderState => {
    this.updateProductState(sliderState, "sensitivity_rank");
  };

  updatePowerRank = sliderState => {
    this.updateProductState(sliderState, "power_rank");
  };

  updateTempRangeRank = sliderState => {
    this.updateProductState(sliderState, "temp_range_rank");
  };

  updateProductName = e => {
    const input = e.target;
    const value = input.value.replace(/[^a-zA-Z]/g, '');
    const product = { ...this.state.product };

    product.name = value;

    this.setState({
      product
    });
  };

  addProduct = () => {
    const product = { ...this.state.product };
    const { products } = this.props;
    const productName = product.name.trim();
    const allProducts = Object.entries(products)
      .map(p => Object.values(p[1]))
      .map(p => p.length > 0 ? p[0].name : null)
      .filter(p => p !== null);

    if (productName.length === 0) {
      this.setState({
        alertText: "Product name cannot be empty",
        showAlert: true
      });
      return;
    }

    if (productName.length > 6) {
      this.setState({
        alertText: "Product name cannot be greater than 6 characters",
        showAlert: true
      });
      return;
    }

    if (allProducts.includes(productName) === true) {
      this.setState({
        alertText:
          "You already have a product with the same name. Please adjust name for this new product.",
        showAlert: true
      });
      return;
    }

    this.setState({
      creatingProduct: true,
      isError: false
    });

    postRequest(`${process.env.REACT_APP_API_URL}team/products/`)
      .send({
        name: productName,
        pixels_rank: product.pixels_rank,
        sensitivity_rank: product.sensitivity_rank,
        power_rank: product.power_rank,
        temp_range_rank: product.temp_range_rank
      })
      .then(res => {
        const {
          minimum_requirement_feedback,
          months_available_to_produce
        } = res.body;
        if (minimum_requirement_feedback === 1) {
          this.showPopup();
        } else if (months_available_to_produce === 0) {
          this.showPopup2();
        }

        this.setState(
          {
            product: {
              name: "",
              pixels_rank: 5,
              sensitivity_rank: 5,
              power_rank: 5,
              temp_range_rank: 5
            },
            creatingProduct: false
          },
          () => {
            this.props.showSuccessMessage(`Product ${productName} was successfully created`);
            incrementUnacceptedDecisions("development");
            window.$("#myModalPDDecisionsProduct").modal("hide");
            this.props.reloadProducts();
            this.props.getSubmissionData();
          }
        );
      })
      .catch(err => {
        this.setState({
          product: {
            name: "",
            pixels_rank: 5,
            sensitivity_rank: 5,
            power_rank: 5,
            temp_range_rank: 5
          },
          creatingProduct: false,
          isError: true
        });

        logError(err, "ModalPDDecisionsAddProduct", "addProduct");
      });
  };

  hideAlert = () => {
    this.setState({
      showAlert: false
    });
  };

  closeCreateProductModal = () => {
    this.setState(
      {
        isError: false
      },
      () => {
        this.props.closeCreateProductModal();
      }
    );
  };

  render() {
    const { product } = this.state;

    return (
      <div>
        <SweetAlert
          show={this.state.showAlert}
          title="Error"
          text={this.state.alertText}
          type="error"
          onConfirm={this.hideAlert}
        />

        <div
          className="modal fade"
          id="myModalPDDecisionsProduct"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {this.state.creatingProduct === true && (
                <Modal.Header>
                  <Modal.Title>In progress</Modal.Title>
                </Modal.Header>
              )}

              {this.state.isError === true && (
                <Modal.Header>
                  <Modal.Title>
                    <div className="alert alert-danger" role="alert">
                      Error
                    </div>
                  </Modal.Title>
                </Modal.Header>
              )}

              {this.state.creatingProduct === false &&
                this.state.isError === false && (
                  <Modal.Header>
                    <Modal.Title>
                      Product Features
                      <HelpIconButtonWithTooltipAndTypeformModal
                        {...MgBusinessCaseContent.PRODUCT_FEATURES}
                      />
                    </Modal.Title>
                  </Modal.Header>
                )}

              <Modal.Body>
                {this.state.creatingProduct === true && (
                  <p style={{ marginBottom: "40px" }}>Creating product...</p>
                )}

                {this.state.isError === true && <p>Cannot create product</p>}

                {this.state.creatingProduct === false &&
                  this.state.isError === false && (
                    <div className="table-responsive mt-20">
                      <table className="table">
                        <tbody>
                          <tr className="text-center border-none">
                            <th>Name</th>
                            <td>
                              <input
                                id="add-product-name-input"
                                type="text"
                                value={product.name}
                                onChange={this.updateProductName}
                              />
                            </td>
                          </tr>
                          <tr
                            id="add-product-resolution-row"
                            className="text-center border-none"
                          >
                            <th>Resolution</th>
                            <td id="add-product-resolution-slider">
                              <Rheostat
                                min={1}
                                max={10}
                                values={[product.pixels_rank]}
                                onChange={this.updatePixelsRank}
                                handle={SliderHandleButton}
                              />
                            </td>
                          </tr>
                          <tr className="text-center border-none">
                            <th>Sensitivity</th>
                            <td>
                              <Rheostat
                                min={1}
                                max={10}
                                values={[product.sensitivity_rank]}
                                onChange={this.updateSensitivityRank}
                                handle={SliderHandleButton}
                              />
                            </td>
                          </tr>
                          <tr className="text-center border-none">
                            <th>Power</th>
                            <td>
                              <Rheostat
                                min={1}
                                max={10}
                                values={[product.power_rank]}
                                onChange={this.updatePowerRank}
                                handle={SliderHandleButton}
                              />
                            </td>
                          </tr>
                          <tr className="text-center border-none">
                            <th>Temperature</th>
                            <td>
                              <Rheostat
                                min={1}
                                max={10}
                                values={[product.temp_range_rank]}
                                onChange={this.updateTempRangeRank}
                                handle={SliderHandleButton}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
              </Modal.Body>

              {this.state.creatingProduct === false &&
                this.state.isError === false && (
                  <Modal.Footer>
                    <Button className="btn btn-cancel" data-dismiss="modal">
                      Cancel
                    </Button>
                    <Button
                      id="add-product-save-button"
                      className="btn btn-save"
                      onClick={this.addProduct}
                    >
                      Save
                    </Button>
                  </Modal.Footer>
                )}

              {this.state.creatingProduct === false &&
                this.state.isError === true && (
                  <Modal.Footer>
                    <Button
                      className="btn btn-save"
                      onClick={this.closeCreateProductModal}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modal/ModalPDDecisionsAddProduct.js